import { defineMessages } from "react-intl";

export default defineMessages({
  superTalent: {
    id: "listworker.superTalent",
    defaultMessage: "<superTalentBadge></superTalentBadge>Super talent",
  },
  statusInfos: {
    id: "superTalent.statusInfos",
    defaultMessage:
      "Ce statut récompense les prestataires <bold>les plus fiables</bold> en leur donnant <bold>une meilleure visibilité.</bold>",
  },

  superTalentGoals: {
    id: "superTalent.superTalentGoals",
    defaultMessage: "Vos objectifs SuperTalent",
  },
  goalsInfos: {
    id: "superTalent.goalsInfos",
    defaultMessage:
      "Chaque mois, nous évaluons si vous avez atteint les objectifs. Atteignez-les et devenez SuperTalent !",
  },
  nextEvaluation: {
    id: "superTalent.nextEvaluation",
    defaultMessage:
      "<magnifyingGlass></magnifyingGlass>Prochaine évaluation :<nextComputedDate></nextComputedDate>",
  },
  visibleByYou: {
    id: "superTalent.visibleByYou",
    defaultMessage: "<eyeIcon></eyeIcon> Uniquement visible par vous",
  },
  repeatRateTitle: {
    id: "repeatRate.repeatRateTitle",
    defaultMessage: "Votre taux de clients récurrents",
  },
  repeatRateInfos: {
    id: "repeatRate.repeatRateInfos",
    defaultMessage:
      "Un taux élevé de clients récurrents témoigne de la qualité de votre travail. Repasser par Ring Twice c'est simple, et en plus vous respectez les règles du jeu. L'objectif SuperTalent dépend de votre catégorie.",
  },
  improveScore: {
    id: "repeatRate.improveScore",
    defaultMessage: "Comment améliorer le score",
  },
  score_value: {
    id: "repeatRate.score_value",
    defaultMessage: "{value} %",
  },
  discover_more: {
    id: "repeatRate.discover_more",
    defaultMessage:
      "Découvrez en plus sur le score de récurrence dans notre Academy.",
  },
  realisationRateTitle: {
    id: "realisationRate.realisationRateTitle",
    defaultMessage: "Votre taux de réalisation",
  },
  realisationRateInfos: {
    id: "realisationRate.realisationRateInfos",
    defaultMessage:
      "Ce taux est la garantie pour vos clients d'un service fait en toute sérénité.<break></break> Offrez-leur donc la meilleure expérience en planifiant au mieux vos rendez-vous.",
  },
  dateComputed: {
    id: "superTalent.dateComputed",
    defaultMessage: "<calendar></calendar>Calculés sur 12 mois",
  },
  cancelation_summary: {
    id: "superTalent.cancelation_summary",
    defaultMessage: "Voir le résumé de mes annulations <RightIcon></RightIcon>",
  },
  no_information: {
    id: "repeatRate.no_information",
    defaultMessage: "-",
  },
  discover_more_realisation: {
    id: "repeatRate.discover_more_realisation",
    defaultMessage:
      "Découvrez en plus sur le taux de réalisation dans notre Academy.",
  },
  photoBookTitle: {
    id: "photo-book.title",
    defaultMessage: "Photos book",
  },
  photoBookSubTitle: {
    id: "photo-book.sub-title",
    defaultMessage: "All photos will be reviewed",
  },
  photoBookSelectPhotoText: {
    id: "photo-book.select-photo-text",
    defaultMessage: "Select to delete a photo",
  },
  photoBookSelectPhotoCountText: {
    id: "photo-book.selected-photo-count-text",
    defaultMessage: "photo selected",
  },
  photoBookDeleteButtonText: {
    id: "photo-book.delete",
    defaultMessage: "Delete",
  },
  photoBookDeleteConfirmationHeader: {
    id: "photo-book.delete-confirmation-header",
    defaultMessage: "Delete photos?",
  },
  photoBookDeleteMessage: {
    id: "photo-book.delete-message",
    defaultMessage: "Your photos will be permanently deleted.",
  },
  photoBookDeleteConfirmButton: {
    id: "photo-book.delete-confirm-button",
    defaultMessage: "Delete Photo",
  },
  photoBookDeleteCancelButton: {
    id: "photo-book.delete-cancel-button",
    defaultMessage: "Cancel",
  },
  photoBookSeeMorePhotos: {
    id: "photo-book.see-more-photos",
    defaultMessage: "See more photos",
  },
  photoBookInstructionTitle: {
    id: "photo-book.instruction.title",
    defaultMessage: "How to take quality photos :",
  },
  photoBookInstruction1: {
    id: "photo-book.instruction.instruction-1",
    defaultMessage: "Lorem ipsum dolor sit amet",
  },
  photoBookInstruction2: {
    id: "photo-book.instruction.instruction-2",
    defaultMessage: "Consectetur adipiscing elit",
  },
  photoBookInstruction3: {
    id: "photo-book.instruction.instruction-3",
    defaultMessage: "Integer molestie lorem at massa",
  },
  photoBookInstruction4: {
    id: "photo-book.instruction.instruction-4",
    defaultMessage: "Facilisis in pretium nisl aliquet",
  },
  photoBookInstruction5: {
    id: "photo-book.instruction.instruction-5",
    defaultMessage: "Lorem ipsum dolor sit amet",
  },
  photoBookAddPhoto: {
    id: "photo-book.add-photo",
    defaultMessage: "Add a photo",
  },
  photoBookUploadSuccessMessage: {
    id: "photo-book.success-message",
    defaultMessage: "Photo uploaded successfully!",
  },
  photoBookUploadErrorMessage: {
    id: "photo-book.error-message",
    defaultMessage: "Something wend wrong while uploading!",
  },
  photoBookSizeValidationErrorMessage: {
    id: "photo-book.size-validation-message",
    defaultMessage:
      "Photo size is too big (Max 10 Mb). Please upload a lighter one.",
  },
  photoBookFileTypeValidationErrorMessage: {
    id: "photo-book.file-type-validation-message",
    defaultMessage:
      "Invalid file type. Allowed types are png, jpg, jpeg, heic.",
  },
  photoBookDeletionSuccessMessage: {
    id: "photo-book.delete-success-message",
    defaultMessage: "Photo deleted successfully!",
  },
  photoBookDeletionErrorMessage: {
    id: "photo-book.delete-error-message",
    defaultMessage: "Something wend wrong while deleting!",
  },
});
